import { DateRangeTimezoneValue } from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { isDateRangeApplied, MaybeDateRange } from 'shared/mui/DatePicker/utils/isDateRangeApplied';

/**
 * Возвращает таймзону фильтра для отправки в URL: она нужна только тогда,
 * когда задан хотя бы один диапазон дат.
 *
 * @example
 * getAppliedTimezone('Europe/Moscow', [1735689600000, 1735776000000]) // → 'Europe/Moscow'
 * getAppliedTimezone('Europe/Moscow', [null, null]) // → null
 */
export function getAppliedTimezone(
  timezone: DateRangeTimezoneValue | undefined,
  ...dateRanges: MaybeDateRange[]
): DateRangeTimezoneValue {
  return dateRanges.some(isDateRangeApplied) ? (timezone ?? null) : null;
}
